import React from 'react';
import '../master.css';
import { useNavigate } from 'react-router-dom';
import { FaList, FaMoneyBill, FaTags, FaUser, FaUsersCog, FaCashRegister, FaCogs, FaGift, FaSitemap, FaThLarge, FaBuilding } from 'react-icons/fa';
import { PiDeviceMobileDuotone } from 'react-icons/pi';
import { BsBuildingLock, BsCloudUpload, BsQrCode } from 'react-icons/bs';
import { BsShopWindow } from 'react-icons/bs';
import { FaGifts, FaTowerObservation } from 'react-icons/fa6';
const masterList = [
  { name: 'Item Master', url: '/admin/master/ItemMaster/Create', icon: <FaList size={50} /> },
  { name: 'Currency Management', url: '/admin/master/CurrencyManagement', icon: <FaMoneyBill size={50} /> },
  { name: 'Tax Management', url: '/admin/master/TaxManagement', icon: <FaTags size={50} /> },
  { name: 'Payment Master', url: '/admin/master/paymentMethod', icon: <FaMoneyBill size={50} /> },
  { name: 'Discount Master', url: '/admin/master/Discount', icon: <FaGift size={50} /> },
  { name: 'Loyality/Gift Master', url: '/admin/master/Promotion', icon: <FaGift size={50} /> },
  // { name: "User Master", url: "/admin/master/userMaster/users", icon: <FaUser size={50} /> },
  // { name: "User Role Master", url: "/admin/master/userMaster/ManageRole", icon: <FaUsersCog size={50} /> },
  { name: 'Counter Master', url: '/admin/itemMaster/CounterMaster', icon: <FaCashRegister size={50} /> },
  // { name: 'Attribute Master', url: '/admin/master/userMaster/users', icon: <FaCogs size={50} /> },
  { name: 'Category Master', url: '/admin/itemMaster/addCategory', icon: <FaSitemap size={50} /> },
  { name: 'Brand Master', url: '/admin/master/brand', icon: <FaTowerObservation size={50} /> },

  { name: 'SubCategory Master', url: '/admin/itemMaster/subCategory', icon: <FaThLarge size={50} /> },
  { name: 'Gift Card Master', url: '/admin/itemMaster/GiftCard', icon: <FaGifts size={50} /> },

  // { name: 'terminal Master', url: '/admin/master/terminal', icon: <PiDeviceMobileDuotone size={50} /> },
  // { name: 'Merchant Master', url: '/admin/master/merchant', icon: <BsShopWindow size={50} /> },
  { name: 'Item Bulk Upload', url: '/admin/master/bulkItems', icon: <BsCloudUpload size={50} /> },
];

const MasterPage = () => {
  const navigate = useNavigate();

  const handleNavigate = (item) => {
    navigate(item);
  };

  return (
    <div className="container-fluid">
      <div className="master-grid">
        {masterList.map((item, index) => (
          <div key={index} onClick={() => handleNavigate(item.url)}>
            <div className="master-card">
              <div className="master-icon">{item.icon}</div>
              <div className="master-name">{item.name}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MasterPage;
